import { createClient } from '@supabase/supabase-js';
import type { Database } from '@vns/core';

// The anon key is designed to be public — Row Level Security is what protects
// the data. The service_role key must never appear anywhere under apps/.
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY.\n' +
      'Copy apps/web/.env.example to apps/web/.env.local and fill it in from\n' +
      'your Supabase dashboard -> Project Settings -> API.',
  );
}

export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Email+password only, so there is no OAuth redirect to detect — which is
    // also what keeps the login flow identical inside a desktop window.
    detectSessionInUrl: false,
  },
});
